// Product Card Variant buy function

function initVariantPicker() {
  document
    .querySelectorAll("variant-selects:not([data-variant-init])")
    .forEach((variantSelectWrapper) => {
      const select = variantSelectWrapper.querySelector("select");
      const formId = select?.getAttribute("form");
      const closestCard = variantSelectWrapper.closest(
        ".product-card-wrapper, .card-wrapper, .product"
      );
      const form = closestCard?.querySelector(`#${formId}`);
      const priceWrapper = closestCard?.querySelector(
        ".card__product__price__cstm"
      );
      const hiddenInput = form?.querySelector('input[name="id"]');
      const submitButton = form?.querySelector('[type="submit"]');
      const variantDataScript = variantSelectWrapper.querySelector(
        'script[type="application/json"]'
      );

      if (
        !select ||
        !form ||
        !hiddenInput ||
        !variantDataScript ||
        !priceWrapper ||
        !submitButton
      )
        return;

      const variantData = JSON.parse(variantDataScript.textContent);

      const formatMoney = (amount) => {
        return `₹ ${(amount / 100).toLocaleString("en-IN", {
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        })}`;
      };

      const updateVariant = (selectedOption) => {
        const matchedVariant = variantData.find(
          (v) => v.option1 === selectedOption
        );
        if (!matchedVariant) return;

        hiddenInput.value = matchedVariant.id;
        hiddenInput.removeAttribute("disabled");

        const priceHTML = `
          <div class="price ${
            matchedVariant.compare_at_price > matchedVariant.price
              ? "price--on-sale"
              : ""
          }">
            <div class="price__container">
              <div class="price__regular">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span class="price-item price-item--regular">
                  ${formatMoney(matchedVariant.price)}
                </span>
              </div>

              ${
                matchedVariant.compare_at_price > matchedVariant.price
                  ? `
                <div class="price__sale">
                  <span class="visually-hidden visually-hidden--inline">Sale price</span>
                  <span class="price-item price-item--sale price-item--last">
                    ${formatMoney(matchedVariant.price)}
                  </span>
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span>
                    <s class="price-item price-item--regular product-page-compare-price cstm-compare-price">
                      ${formatMoney(matchedVariant.compare_at_price)}
                    </s>
                  </span>
                </div>
              `
                  : ""
              }

              <small class="unit-price caption hidden">
                <span class="visually-hidden">Unit price</span>
                <span class="price-item price-item--last">
                  <span></span>
                  <span aria-hidden="true">/</span>
                  <span class="visually-hidden"> per </span>
                  <span></span>
                </span>
              </small>
            </div>
          </div>
        `;
        priceWrapper.innerHTML = priceHTML;

        // Update price, image, and form values immediately
        submitButton.disabled = true; // keep this to prevent accidental clicks

        // Defer just the button logic
        requestAnimationFrame(() => {
          if (matchedVariant.available) {
            submitButton.disabled = false;
            submitButton.removeAttribute("data-out-of-stock");

            const productFormWrapper = form.closest("product-form");
            const errorWrapper = productFormWrapper?.querySelector(
              ".product-form__error-message-wrapper"
            );
            if (errorWrapper) errorWrapper.setAttribute("hidden", "");
          } else {
            submitButton.disabled = true;
            submitButton.setAttribute("data-out-of-stock", "true");
          }
        });

        const mainImage = closestCard?.querySelector(
          ".product-first-image img"
        );

        if (mainImage && matchedVariant.featured_image) {
          const baseSrc = matchedVariant.featured_image.src || "";
          const cleanSrc = baseSrc.split("?")[0];
          const version = "1749719735"; // Keep fixed for cache/CDN match

          const widths = [
            180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2160,
          ];
          const srcset = widths
            .map((w) => `${cleanSrc}?v=${version}&width=${w} ${w}w`)
            .join(", ");

          const newAlt =
            matchedVariant.featured_image.alt ||
            matchedVariant.title ||
            "Product image";

          mainImage.src = `${cleanSrc}?crop=center&height=1080&width=1080&v=${version}`;
          mainImage.alt = newAlt;
          mainImage.srcset = srcset;
        }
      };

      // Initial event listener for user change
      select.addEventListener("change", function () {
        updateVariant(this.value);
      });

      // Mark this as initialized
      variantSelectWrapper.setAttribute("data-variant-init", "true");

      // Optionally, trigger update immediately on load
      updateVariant(select.value);
    });
  window.addEventListener("pageshow", () => {
    requestAnimationFrame(() => {
      document
        .querySelectorAll("variant-selects[data-variant-init]")
        .forEach((variantSelectWrapper) => {
          const select = variantSelectWrapper.querySelector("select");
          const formId = select?.getAttribute("form");
          const closestCard = variantSelectWrapper.closest(
            ".product-card-wrapper, .card-wrapper, .product"
          );
          const form = closestCard?.querySelector(`#${formId}`);
          const priceWrapper = closestCard?.querySelector(
            ".card__product__price__cstm"
          );
          const hiddenInput = form?.querySelector('input[name="id"]');
          const submitButton = form?.querySelector('[type="submit"]');
          const variantDataScript = variantSelectWrapper.querySelector(
            'script[type="application/json"]'
          );

          if (
            !select ||
            !form ||
            !hiddenInput ||
            !variantDataScript ||
            !priceWrapper ||
            !submitButton
          )
            return;

          const variantData = JSON.parse(variantDataScript.textContent);

          const formatMoney = (amount) => {
            return `₹ ${(amount / 100).toLocaleString("en-IN", {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            })}`;
          };

          const updateVariant = (selectedOption) => {
            const matchedVariant = variantData.find(
              (v) => v.option1 === selectedOption
            );
            if (!matchedVariant) return;

            // Update hidden input
            hiddenInput.value = matchedVariant.id;
            hiddenInput.removeAttribute("disabled");

            // Update price
            const priceHTML = `
            <div class="price ${
              matchedVariant.compare_at_price > matchedVariant.price
                ? "price--on-sale"
                : ""
            }">
              <div class="price__container">
                <div class="price__regular">
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span class="price-item price-item--regular">
                    ${formatMoney(matchedVariant.price)}
                  </span>
                </div>

                ${
                  matchedVariant.compare_at_price > matchedVariant.price
                    ? `
                  <div class="price__sale">
                    <span class="visually-hidden visually-hidden--inline">Sale price</span>
                    <span class="price-item price-item--sale price-item--last">
                      ${formatMoney(matchedVariant.price)}
                    </span>
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span>
                      <s class="price-item price-item--regular product-page-compare-price cstm-compare-price">
                        ${formatMoney(matchedVariant.compare_at_price)}
                      </s>
                    </span>
                  </div>
                `
                    : ""
                }

                <small class="unit-price caption hidden">
                  <span class="visually-hidden">Unit price</span>
                  <span class="price-item price-item--last">
                    <span></span>
                    <span aria-hidden="true">/</span>
                    <span class="visually-hidden"> per </span>
                    <span></span>
                  </span>
                </small>
              </div>
            </div>
          `;
            priceWrapper.innerHTML = priceHTML;

            // Update image, price, and form values immediately
            submitButton.disabled = true; // keep this to prevent accidental clicks

            // Defer just the button logic
            requestAnimationFrame(() => {
              if (matchedVariant.available) {
                submitButton.disabled = false;
                submitButton.removeAttribute("data-out-of-stock");

                const productFormWrapper = form.closest("product-form");
                const errorWrapper = productFormWrapper?.querySelector(
                  ".product-form__error-message-wrapper"
                );
                if (errorWrapper) errorWrapper.setAttribute("hidden", "");
              } else {
                submitButton.disabled = true;
                submitButton.setAttribute("data-out-of-stock", "true");
              }
            });

            // Update the main image based on the variant
            const mainImage = closestCard?.querySelector(
              ".product-first-image img"
            );

            if (mainImage && matchedVariant.featured_image) {
              const baseSrc = matchedVariant.featured_image.src || "";
              const cleanSrc = baseSrc.split("?")[0];
              const version = "1749719735"; // Keep fixed for cache/CDN match

              const widths = [
                180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100,
                2160,
              ];
              const srcset = widths
                .map((w) => `${cleanSrc}?v=${version}&width=${w} ${w}w`)
                .join(", ");

              const newAlt =
                matchedVariant.featured_image.alt ||
                matchedVariant.title ||
                "Product image";

              mainImage.src = `${cleanSrc}?crop=center&height=1080&width=1080&v=${version}`;
              mainImage.alt = newAlt;
              mainImage.srcset = srcset;
            }
          };

          // Initial event listener for user change
          select.addEventListener("change", function () {
            updateVariant(this.value);
          });

          // Mark this as initialized
          variantSelectWrapper.setAttribute("data-variant-init", "true");

          // Optionally, trigger update immediately on load
          updateVariant(select.value);
        });
    });
  });
}
